<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';
import { defineEmits } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <!-- Rail card (CrmB): white card with a small uppercase title; the body
       opens inside the same card. -->
  <div class="text-sm rounded-[10px] border border-n-weak bg-n-solid-2">
    <button
      class="flex items-center select-none w-full m-0 cursor-grab justify-between px-3.5 py-2.5 drag-handle"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-1.5 min-w-0">
        <EmojiOrIcon
          v-if="icon || emoji"
          class="inline-block w-4 text-n-slate-10"
          :icon="icon"
          :emoji="emoji"
        />
        <h5
          class="m-0 py-0 text-[10.5px] font-semibold tracking-[0.1em] uppercase truncate text-n-slate-10"
        >
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-1">
        <slot name="button" />
        <span
          class="i-lucide-chevron-down size-3.5 text-n-slate-9 transition-transform"
          :class="{ 'rotate-180': isOpen }"
        />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="border-t border-n-weak"
      :class="compact ? 'p-0' : 'px-2 py-3'"
    >
      <slot />
    </div>
  </div>
</template>
